<template>
    <section>
        <modal v-if="showModal" @close="showModal = false"
            v-on:keydown.esc="showModal = false"
            :title="'Eliminar rol de Cobradora: ' + (collector ? collector.fullName : '')"
            :sizeOfModal="'small'"
            :showElement="showModal">
            <template v-slot:modalContent>
                <sui-message info size="small">
                <p>
                    <i class="info circle icon"></i>
                    Esta Cobradora:
                    <ul>
                        <li>No tiene promotoras asignadas</li>
                        <li>
                            Cuenta con <strong>{{ credits.length }} créditos </strong> asignados
                            <span v-if="credits.length > 0">(se asignarán a la nueva cobradora).</span>
                        </li>
                    </ul>
                </p>
                </sui-message>
                <form class="ui form" @submit.prevent>
                    <div class="field required">
                        <label>Cobradora</label>
                        <sui-dropdown
                            fluid
                            placeholder="Selecciona una cobradora..."
                            selection
                            search
                            :options="replacementCollectorOptions"
                            v-model="record.replacementCollectorId"
                        />
                    </div>
                </form>
            </template>
            <template v-slot:modalFooter>
                <div class="actions">
                    <sui-button primary :disabled="!record.replacementCollectorId" @click="confirm()">Reasignar y quitar</sui-button>
                    <sui-button @click="confirm(true)">Cancelar</sui-button>
                </div>
            </template>
        </modal>
    </section>
</template>

<script>
import Modal from '@/components/Helpers/Modal.vue'

export default {
    name: 'ReassignCreditsAndRemoveModal',
    components: { Modal },
    props: ['showModal', 'collector', 'credits', 'replacementCollectorOptions'],

    data () {
        return {
            record: { replacementCollectorId: null, cancel: false }
        }
    },

    watch: {
        showModal (val) {
            if (val) {
                this.record = { replacementCollectorId: null, cancel: false }
            }
        }
    },

    methods: {
        confirm (cancel = false) {
            if (cancel) {
                this.record.cancel = true
                this.$emit('modalResponse', this.record)
                return
            }
            this.$swal({
                title: '¿Deseas continuar?',
                html: 'Se reasignarán los créditos a la nueva cobradora y se eliminará el rol.',
                icon: 'question',
                showCancelButton: true,
                confirmButtonText: 'Si, continuar',
                confirmButtonColor: '#2BBA45',
                cancelButtonColor: '#d33',
                cancelButtonText: 'No',
                allowOutsideClick: false,
                showCloseButton: false
            }).then((result) => {
                if (result.value) {
                    this.record.cancel = false
                    this.$emit('modalResponse', this.record)
                }
            })
        }
    }
}
</script>
